import { useTheme } from '@emotion/react';
import PropTypes from 'prop-types';
import { useCallback, useRef, useState } from 'react';

import Block from 'shopper/components/Block';
import Button from 'shopper/components/Button';
import Divider from 'shopper/components/Divider';
import Icon from 'shopper/components/Icon';

import { sendEvent } from 'lib/gtag';

import CategoriesDropdown from './CategoriesDropdown';
import StoresDropdownButton from './StoresDropdownButton';
import TopbarBottomNav from './TopbarBottomNav';

import TOPBAR from 'constants/topbar';
import Z_INDEX_SCALE from 'constants/zIndexScale';

const TopbarBottomLeftDefaultNav = ({
  commentsCount,
  gaEventCategory,
  onLastCommentsClick,
}) => {
  const [isCategoryOpen, setCategoryOpen] = useState(false);
  const [activeCategory, setActiveCategory] = useState(null);
  const categoriesButtonElem = useRef(null);
  const theme = useTheme();

  const onCategoriesButtonClick = () => {
    sendEvent({ action: 'categories_click', category: gaEventCategory });
    setCategoryOpen((prev) => !prev);
  };

  const onCategoriesDropdownClose = useCallback(() => {
    setCategoryOpen(false);
    setActiveCategory(null);
  }, []);

  return (
    <>
      <Block
        position="relative"
        zIndex={isCategoryOpen ? Z_INDEX_SCALE.SIZE_6 : 'unset'}
        onMouseLeave={() => setActiveCategory(null)}
      >
        <Button
          size="size2"
          data-test-selector="open-categories-dropdown"
          type={isCategoryOpen ? 'subtle' : 'ghost'}
          iconLeft={<Icon name="menu" />}
          iconRight={
            isCategoryOpen ? (
              <Icon name="arrow-up" />
            ) : (
              <Icon name="arrow-down" />
            )
          }
          ref={categoriesButtonElem}
          position={isCategoryOpen ? 'relative' : 'unset'}
          zIndex={isCategoryOpen ? Z_INDEX_SCALE.SIZE_6 : 'unset'}
          onClick={onCategoriesButtonClick}
        >
          {TOPBAR.DROPDOWN_CATEGORY}
        </Button>
        <CategoriesDropdown
          activeCategory={activeCategory}
          openerRef={categoriesButtonElem}
          isOpen={isCategoryOpen}
          setActiveCategory={setActiveCategory}
          onClose={onCategoriesDropdownClose}
        />
      </Block>
      <Divider height={24} mx={4} borderColor={theme.app.topbar.borderBg} />
      <StoresDropdownButton />
      <TopbarBottomNav
        commentsCount={commentsCount}
        gaEventCategory={gaEventCategory}
        onLastCommentsClick={onLastCommentsClick}
      />
    </>
  );
};

TopbarBottomLeftDefaultNav.defaultProps = {
  commentsCount: null,
};

TopbarBottomLeftDefaultNav.propTypes = {
  commentsCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  gaEventCategory: PropTypes.string.isRequired,
  onLastCommentsClick: PropTypes.func.isRequired,
};

export default TopbarBottomLeftDefaultNav;
